<template lang="html">
  <div class="col-md-4 col-sm-6 p-1 my-2" :class="{'col-lg-3': $route.path !== '/products'}">
    <div class="product-container shadow rounded">
      <div class="product-img border-bottom">
        <img :src="product.photo ||'/images/products/product_' + Math.ceil(Math.random() * 12 )+'.jpg'" class="w-100" height="250px" :alt="product.Product_name" style="overflow: hidden">
      </div>
      <div v-if="isLoggedIn" class="position-relative d-flex align-items-center justify-content-center">
        <button @click="addToShopCart" title="add to cart" class="add-cart-btn btn btn-danger d-none align-items-center justify-content-center"></button>
        <button @click="AddToWishList" title="add to wish list" class="add-wish-btn btn btn-danger d-none align-items-center justify-content-center"><i class="fa fa-heart h5 mb-0" aria-hidden="true"></i></button>
      </div>
      <div class="product-info text-center mt-4 pb-5">
        <h5>{{product.Product_name}}</h5>
        <h6 class="text-danger">${{product.price}}</h6>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import {mapMutations} from 'vuex';
export default {
  data(){
    return{
      isLoggedIn: false
    }
  },
  props:["product"],
  mounted(){
    window.localStorage.getItem('care_user_auth_token') ? this.isLoggedIn = true : this.isLoggedIn = false
  },
  computed:{
    api(){
      return this.$store.state.api;
    }
  },
  methods:{
    AddToWishList(){
      fetch(`${this.api}/client/wishlist`,{
        method: "POST",
        headers:{
          "Content-Type": "application/json",
          "Authorization": localStorage.getItem('care_user_auth_token')
        },
        body:JSON.stringify({product_id: this.product.id})
      })
      .then(res=> res.json())
      .then(data => {
        if(data.status){
          Swal.fire({
            title: 'Success!',
            text: 'the product added to wish list',
            icon: 'success',
            confirmButtonText: 'OK.'
          })
        }
      })
      .catch(err => console.log(err))
    },
    ...mapMutations(["addToCart"]),
    addToShopCart(){
      this.addToCart(this.product);
      Swal.fire({
        title: 'Success!',
        text: 'the product added to cart',
        icon: 'success',
        confirmButtonText: 'OK.'
      })
    }
  }
}
</script>

<style lang="css" scoped>

.add-cart-btn, .add-wish-btn{
  width: 60px;
  height: 60px;
  border-radius: 50%;
  position: absolute;
  left:5px;
  border: 8px solid #FFF;
  font-size: 30px;
  background: #222;
}
.add-cart-btn::after{
  content: "\f07a";
  font-family: "FontAwesome";
  font-size: 20px
}
.add-wish-btn{
  left: calc(100% - 65px)
}
.product-container:hover .add-cart-btn, .product-container:hover .add-wish-btn{
  display: flex !important
}
.add-cart-btn:hover, .add-wish-btn:hover{
  background: #f65858
}
.product-img{
  overflow: hidden;
}
.product-img>img{
  background-size: cover;
  background-position: center center;
  transition: all .4s ease;
}
.product-img:hover img{
  transform: scale(1.7, 1.7)
}
</style>
